import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import useInterfaceLocale from '@aytm/app/swidget/base/modules/locale/useInterfaceLocale'
import useSession from '@aytm/app/swidget/base/session/useSession'
import useViewport from '../../modules/viewport/useViewport'

import { ActionType, IAction } from '@aytm/app/swidget/base/actions/types'

import SideText from './SideText'

import style from './style.module.scss'

export interface ISideTextButtonProps {
  action: IAction
}

const SideTextButton = React.memo<ISideTextButtonProps>(
  ({ action }) => {
    const [showSidebar, setShowSidebar] = useState(true)

    const { t } = useInterfaceLocale()
    const session = useSession()
    const viewport = useViewport()

    useEffect(() => {
      if (showSidebar && viewport.mobile) {
        session.element.style.height = '0'
        session.element.style.overflow = 'hidden'
      } else {
        session.element.style.height = ''
        session.element.style.overflow = ''
      }
    }, [session.element, showSidebar, viewport.mobile])

    return ActionType.ASK === action.action ? (
      <>
        <div className={style.button} role="presentation">
          <i className="icon-aytmfd-info" onClick={() => void setShowSidebar(true)} />
        </div>
        {showSidebar &&
          createPortal(
            <SideText
              onClose={() => void setShowSidebar(false)}
              mobileLayout={true}
              action={action}
              title={t('sidebar', 'title')}
            />,
            session.element
          )}
      </>
    ) : null
  },
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

SideTextButton.displayName = 'RepeatVideos'

export default SideTextButton
